import { render, staticRenderFns } from "./AddRentalClothesProduct.vue?vue&type=template&id=1169b5d8&"
import script from "./AddRentalClothesProduct.vue?vue&type=script&lang=js&"
export * from "./AddRentalClothesProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports